<template>
<div class="component i18n-picker" :class="{ 'i18n-picker--light': light}">
  <label class="picker__label" for="i18n-picker"><i class="material-icons">language</i></label>
  <select id="i18n-picker" class="picker" v-model="locale">
    <option class="picker__option" value="zh-Hant">繁體中文</option>
    <option class="picker__option" value="en">English</option>
    <option class="picker__option" value="vi">Tiếng Việt</option>
    <option class="picker__option" value="th">อักษรไทย</option>
  </select>
</div>
</template>

<script>
import * as moment from 'moment';
import Cookies from 'js-cookie';

import { zhTW } from '../helpers/moment-locale';

export default {
  name: 'I18n-Picker',
  props: {
    light: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      locale: this.$i18n.locale,
    };
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;

      if (['en', 'vi', 'th'].includes(value)) {
        switch (value) {
          case 'en': {
            const isMonthMiddle = Number(new Date(2024, 0, 2).toLocaleDateString().split('/')[1]) === 1;
            const isDateLeading = Number(new Date(2024, 0, 2).toLocaleDateString().split('/')[0]) === 2;

            if (isDateLeading && isMonthMiddle) {
              moment.updateLocale('en', {
                // eslint-disable-next-line no-underscore-dangle
                longDateFormat: moment.localeData('en-au')._longDateFormat,
              });
            } else {
              this.$moment.locale(value);
            }
          }
            break;

          default:
            this.$moment.locale(value);

            break;
        }
      } else {
        moment.locale('zh-Hant-my-settings', zhTW);

        moment.defineLocale('zh-Hant', {
          parentLocale: 'zh-TW',
        });

        this.$moment.locale('zh-Hant');
      }

      if (process.env.NODE_ENV === 'development') {
        Cookies.set('lang', value, { expires: 3560 });
      } else {
        Cookies.set('lang', value, { expires: 3560, domain: '.ocard.co' });
      }

      this.$gtm.trackEvent({
        event: '手動選擇語言',
        label: value,
      });
      this.$emit('locale-changed', value);
    },
  },
};
</script>

<style lang="sass" scoped>
.component
  margin: 5% 0
  display: flex
  justify-content: center
  align-self: center

  &.i18n-picker--light
    margin: 0
    justify-content: flex-start

.picker
  padding: 0

  border: none

  background: transparent

  color: rgba(255, 255, 255, .5)

  appearance: none

  .i18n-picker--light &
    color: #B0BEC5
    font-weight: bold

  &:focus
    outline: none

  &__label
    height: 24px
    margin: 0 5px 0 0

    color: rgba(255, 255, 255, .5)

    .material-icons
      font-size: 1rem

      line-height: 24px

      .i18n-picker--light &
        color: #B0BEC5
        font-weight: bold

  &__option
    min-height: auto
    padding: 0

    color: #333
</style>
